import { Container, PageHeading } from '~/components'

import { TermsContent } from '../components'

export const TermsPage = () => {
  return (
    <main className="pb-36 pt-6 md:pt-10">
      <Container className="flex flex-col gap-y-10">
        <PageHeading>利用規約</PageHeading>
        <section>
          <TermsContent />
        </section>
      </Container>
    </main>
  )
}
